/**
 * 时间处理工具函数，统一使用北京时间 (Asia/Shanghai)
 */

// 北京时间时区常量
export const BEIJING_TIME_ZONE = 'Asia/Shanghai'

/**
 * 格式化日期时间
 * @param {string|Date} date - 日期对象或字符串
 * @param {string} format - 格式字符串，默认为 'YYYY-MM-DD HH:mm:ss'
 * @returns {string} 格式化后的日期时间字符串
 */
export const formatDateTime = (date, format = 'YYYY-MM-DD HH:mm:ss') => {
  if (!date) return ''
  
  const d = new Date(date)
  // 确保使用北京时间
  const utcOffset = 8 * 60 * 60 * 1000 // UTC+8偏移量（毫秒）
  const beijingTime = new Date(d.getTime() + (d.getTimezoneOffset() * 60 * 1000) + utcOffset)
  
  const year = beijingTime.getFullYear()
  const month = String(beijingTime.getMonth() + 1).padStart(2, '0')
  const day = String(beijingTime.getDate()).padStart(2, '0')
  const hours = String(beijingTime.getHours()).padStart(2, '0')
  const minutes = String(beijingTime.getMinutes()).padStart(2, '0')
  const seconds = String(beijingTime.getSeconds()).padStart(2, '0')
  
  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds)
}

/**
 * 格式化日期
 * @param {string|Date} date - 日期对象或字符串
 * @param {string} format - 格式字符串，默认为 'YYYY-MM-DD'
 * @returns {string} 格式化后的日期字符串
 */
export const formatDate = (date, format = 'YYYY-MM-DD') => {
  return formatDateTime(date, format)
}

/**
 * 将日期时间转换为ISO格式（北京时间）
 * @param {string|Date} date - 日期对象或字符串
 * @returns {string} ISO格式的日期时间字符串
 */
export const toISOString = (date) => {
  if (!date) return ''
  
  const d = new Date(date)
  // 确保使用北京时间
  const utcOffset = 8 * 60 * 60 * 1000 // UTC+8偏移量（毫秒）
  const beijingTime = new Date(d.getTime() + (d.getTimezoneOffset() * 60 * 1000) + utcOffset)
  
  return beijingTime.toISOString()
}

/**
 * 获取当前北京时间
 * @returns {Date} 当前北京时间的Date对象
 */
export const getCurrentBeijingTime = () => {
  const now = new Date()
  const utcOffset = 8 * 60 * 60 * 1000 // UTC+8偏移量（毫秒）
  return new Date(now.getTime() + (now.getTimezoneOffset() * 60 * 1000) + utcOffset)
}

/**
 * 将日期字符串转换为北京时间的Date对象
 * @param {string} dateString - 日期字符串
 * @returns {Date} 北京时间的Date对象
 */
export const parseBeijingTime = (dateString) => {
  if (!dateString) return null
  
  const d = new Date(dateString)
  // 确保使用北京时间
  const utcOffset = 8 * 60 * 60 * 1000 // UTC+8偏移量（毫秒）
  return new Date(d.getTime() + (d.getTimezoneOffset() * 60 * 1000) + utcOffset)
}
